import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "common/locales";
import { BEGINNING_OF_TIME, useMetabaseUrl } from "model";
import { useCurrentFarm } from "model/useFarmQueries";
import { useMemo } from "react";

const ScrollContainer = styled("div")({
  display: "flex",
  overflowX: "auto",
  gap: "16px",
  padding: "8px 0",

  /* Hide scrollbar for Chrome, Safari and Opera */
  "&::-webkit-scrollbar": {
    display: "none",
  },

  /* Hide scrollbar for IE, Edge and Firefox */
  msOverflowStyle: "none",
  scrollbarWidth: "none",
});

const SummaryCard = styled(Box)({
  position: "relative",
  border: "0.92px solid #e4e4e7",
  borderRadius: "13.798px",
  height: "314.594px",
  minWidth: "320px",
  maxWidth: "400px",
  overflow: "hidden",
  backgroundColor: "#ffffff",
  flexShrink: 0,
});

const LoadingCard = styled(Box)({
  minWidth: "320px",
  maxWidth: "400px",
  height: "314px",
  border: "0.92px solid #e4e4e7",
  borderRadius: "13.798px",
  backgroundColor: "white",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
});

export default function YieldInsightsCards() {
  const { t } = useTranslation();
  const { data: currentFarm } = useCurrentFarm();

  const params = useMemo(
    () => ({
      date_filter: BEGINNING_OF_TIME,
      farm_guid: currentFarm?.guid ?? "",
    }),
    [currentFarm?.guid]
  );

  const { data: metabaseData } = useMetabaseUrl(
    "YIELD_SUMMARY",
    params,
    !!currentFarm?.guid
  );

  const yieldSummaryMetabaseUrl = metabaseData?.url ?? "";

  return (
    <Box>
      <ScrollContainer>
        {/* Yield Summary Card */}
        {yieldSummaryMetabaseUrl ? (
          <SummaryCard>
            <iframe
              frameBorder="0"
              src={yieldSummaryMetabaseUrl}
              width="100%"
              height="100%"
              title="Yield-Summary"
              style={{
                border: "none",
                display: "block",
                width: "100%",
                height: "100%",
              }}
            />
          </SummaryCard>
        ) : (
          <LoadingCard>
            <Typography variant="body2" color="text.secondary">
              {t("loading")}...
            </Typography>
          </LoadingCard>
        )}
      </ScrollContainer>
    </Box>
  );
}
